(function () {
  'use strict';

  function initHolyBanner(canvas) {
    var ctx = canvas.getContext('2d');
    var W, H, motes = [], shafts = [];

    function resize() {
      var parent = canvas.parentElement;
      W = canvas.width = parent ? parent.offsetWidth : 1200;
      H = canvas.height = parent ? parent.offsetHeight : 600;
    }

    function Mote() { this.reset(true); }
    Mote.prototype.reset = function (initial) {
      this.x = Math.random() * (W || 1200);
      this.y = initial ? Math.random() * (H || 600) : (H || 600) + 10;
      this.vx = (Math.random() - 0.5) * 0.4;
      this.vy = -(Math.random() * 0.7 + 0.15);
      this.size = Math.random() * 3 + 0.5;
      this.life = initial ? Math.floor(Math.random() * 300) : 0;
      this.maxLife = Math.random() * 280 + 100;
      this.opacity = 0;
      this.maxOp = Math.random() * 0.65 + 0.08;
      this.twinkle = Math.random() * 0.06 + 0.015;
      this.twinklePhase = Math.random() * Math.PI * 2;
      this.isStar = Math.random() < 0.2;
    };

    Mote.prototype.update = function () {
      this.life++;
      this.x += this.vx;
      this.y += this.vy;
      var r = this.life / this.maxLife;
      if (r < 0.12) {
        this.opacity = (r / 0.12) * this.maxOp;
      } else if (r < 0.75) {
        this.opacity = this.maxOp * (0.72 + 0.28 * Math.sin(this.life * this.twinkle + this.twinklePhase));
      } else {
        this.opacity = ((1 - r) / 0.25) * this.maxOp;
      }
      if (this.life >= this.maxLife || this.y < -20) this.reset(false);
    };

    Mote.prototype.draw = function () {
      if (this.opacity < 0.005) return;
      ctx.save();
      ctx.globalAlpha = this.opacity;
      if (this.isStar) {
        ctx.strokeStyle = 'rgba(255,245,170,1)';
        ctx.lineWidth = this.size * 0.35;
        ctx.lineCap = 'round';
        var s = this.size * 3.5;
        ctx.beginPath(); ctx.moveTo(this.x - s, this.y); ctx.lineTo(this.x + s, this.y); ctx.stroke();
        ctx.beginPath(); ctx.moveTo(this.x, this.y - s); ctx.lineTo(this.x, this.y + s); ctx.stroke();
        ctx.lineWidth = this.size * 0.15;
        ctx.globalAlpha = this.opacity * 0.45;
        var d = s * 0.6;
        ctx.beginPath(); ctx.moveTo(this.x - d, this.y - d); ctx.lineTo(this.x + d, this.y + d); ctx.stroke();
        ctx.beginPath(); ctx.moveTo(this.x + d, this.y - d); ctx.lineTo(this.x - d, this.y + d); ctx.stroke();
      } else {
        var g = ctx.createRadialGradient(this.x, this.y, 0, this.x, this.y, this.size * 2.5);
        g.addColorStop(0, 'rgba(255,252,200,1)');
        g.addColorStop(0.35, 'rgba(255,215,0,0.75)');
        g.addColorStop(1, 'rgba(255,215,0,0)');
        ctx.fillStyle = g;
        ctx.beginPath();
        ctx.arc(this.x, this.y, this.size * 2.5, 0, Math.PI * 2);
        ctx.fill();
      }
      ctx.restore();
    };

    function Shaft() { this.reset(true); }
    Shaft.prototype.reset = function (initial) {
      this.x = (Math.random() * 0.8 + 0.1) * (W || 1200);
      this.w = Math.random() * 70 + 25;
      this.life = initial ? Math.floor(Math.random() * 350) : 0;
      this.maxLife = Math.random() * 400 + 180;
      this.opacity = 0;
      this.maxOp = Math.random() * 0.07 + 0.015;
      this.drift = (Math.random() - 0.5) * 0.12;
    };

    Shaft.prototype.update = function () {
      this.life++;
      this.x += this.drift;
      var r = this.life / this.maxLife;
      if (r < 0.3) this.opacity = (r / 0.3) * this.maxOp;
      else if (r < 0.7) this.opacity = this.maxOp;
      else this.opacity = ((1 - r) / 0.3) * this.maxOp;
      if (this.life >= this.maxLife) this.reset(false);
    };

    Shaft.prototype.draw = function () {
      if (this.opacity < 0.003) return;
      ctx.save();
      ctx.globalAlpha = this.opacity;
      var g = ctx.createLinearGradient(0, 0, 0, H || 600);
      g.addColorStop(0, 'rgba(255,252,215,0.95)');
      g.addColorStop(0.35, 'rgba(255,240,150,0.6)');
      g.addColorStop(0.7, 'rgba(255,220,80,0.2)');
      g.addColorStop(1, 'rgba(255,215,0,0)');
      ctx.fillStyle = g;
      ctx.beginPath();
      ctx.moveTo(this.x - this.w * 0.15, 0);
      ctx.lineTo(this.x + this.w * 0.15, 0);
      ctx.lineTo(this.x + this.w, H || 600);
      ctx.lineTo(this.x - this.w, H || 600);
      ctx.closePath();
      ctx.fill();
      ctx.restore();
    };

    for (var i = 0; i < 65; i++) motes.push(new Mote());
    for (var j = 0; j < 6; j++) shafts.push(new Shaft());

    function loop() {
      ctx.clearRect(0, 0, W, H);
      shafts.forEach(function (s) { s.update(); s.draw(); });
      motes.forEach(function (m) { m.update(); m.draw(); });
      requestAnimationFrame(loop);
    }

    resize();
    window.addEventListener('resize', function () { resize(); });
    loop();
  }

  function onReady() {
    document.querySelectorAll('.sancti-holy-canvas').forEach(function (canvas) {
      initHolyBanner(canvas);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }
})();
